import {useContext} from "react"
import {LexiconsContext} from "../contexts/LexiconsContext"

export function useLexiconsContext() {
    const context = useContext(LexiconsContext)
    if (!context) {
        throw new Error("useLexiconsContext must be used within a LexiconsProdider")
    }
    return context
}